import React from 'react'
import { Loader } from '../../../common/Loader'
import { Tabs } from '../../../common/Tabs'
import { CostItem, EstimatedFees, EstimatedProfit } from '../components/CostItem'
import { LoaderContainer, TabsItemStyle, TabsListStyle } from '../styled'
import * as S from './styled'
import { SellingPriceInput } from './SellingPriceInput'

type PerSizePricingData = {
  price: string
  cost: number
  feesValue: number
  unitProfit: number
  label: string
}

type PerSizePricingProps = {
  includeFeesValue: boolean
  data: PerSizePricingData[]
  onPriceChange: (price: string, index: number) => void
}

export const PerSizePricing = ({ includeFeesValue, data, onPriceChange }: PerSizePricingProps) => {
  if (!data.length) {
    return (
      <LoaderContainer>
        <Loader size="large" />
      </LoaderContainer>
    )
  }

  if (data.length === 1) {
    return (
      <>
        <SellingPriceInput
          value={data[0].price.toString()}
          onValueChange={(value) => onPriceChange(value, 0)}
        />
        <CostItem name="Manufacturing costs" value={data[0].cost || 0} negative />
        {includeFeesValue && <EstimatedFees value={data[0].feesValue} />}
        <EstimatedProfit value={data[0].unitProfit} />
      </>
    )
  }

  return (
    <Tabs>
      <S.TabsListContainer>
        <Tabs.List style={TabsListStyle}>
          {data?.map((tab) => (
            <Tabs.Item key={tab.label} style={TabsItemStyle} name={tab.label} variant="dimmed" />
          ))}
        </Tabs.List>
      </S.TabsListContainer>
      {data?.map((tab, index) => {
        return (
          <Tabs.Panel key={`${tab.label}-${index}`}>
            <>
              <SellingPriceInput
                key={`${tab.label}-${index}-input`}
                value={tab.price.toString()}
                onValueChange={(value) => onPriceChange(value, index)}
              />
              <CostItem name="Manufacturing costs" value={tab.cost || 0} negative />
              {includeFeesValue && <EstimatedFees value={tab.feesValue} />}
              <EstimatedProfit value={tab.unitProfit} />
            </>
          </Tabs.Panel>
        )
      })}
    </Tabs>
  )
}
